/*
 * @Description:
 * @Date: 2020-11-06 16:31:41
 */
import dateFormat from '@/tools/dateFormat';

export default {
  index: {
    width: '80px',
    label: '序号',
    type: 'index'
  },
  fullName: {
    width: 160,
    label: '项目参与人',
    prop: 'fullName'
  },
  phone: {
    width: 140,
    label: '手机号',
    prop: 'phone'
  },
  taskDt: {
    width: 140,
    label: '任务月度',
    prop: 'taskDt'
  },
  revokeCount: {
    label: '撤回任务量',
    prop: 'revokeSum',
    formatter(row) {
      const { revokeSum, passSum, passIngSum } = row;
      return `${revokeSum}（审核通过：${passSum}；审核中：${passIngSum}）`;
    }
  },
  revokeDt: {
    width: 180,
    label: '撤回时间',
    prop: 'createDt',
    formatter(row, ctx, v) {
      return dateFormat(v);
    }
  },
  enterpriseName: {
    label: '个体名称',
    prop: 'enterpriseName'
  }
};
